const defaultOptions = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  trailingZeroDisplay: 'stripIfInteger',
};

const formatNumber = (input?: number | null, options = {}) => {
  return typeof input === 'number'
    ? Intl.NumberFormat('en-US', {
        ...defaultOptions,
        ...options,
      }).format(input)
    : '--';
};

export default formatNumber;
